// @flow

import styled from 'styled-components';
import { px, py } from 'styled-components-spacing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { PRIMARY_BUTTON } from '@components/StatefulButton/constants';
import { StatefulButton } from '@components';

import theme from '@theme';

export const StyledCover = styled.div`
  display: flex;
  flex-direction: column;

  background-color: ${theme.colors.white};

  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  z-index: 1001;
  margin: 0;
`;

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;

  height: 64px;

  align-items: center;
  justify-content: center;
`;

export const StyledBackButton = styled(FontAwesomeIcon)`
  color: ${theme.colors.aquaMarine};
  font-size: 16px;
  font-weight: 600;

  ${px(3)}
  ${py(3.5)}
`;

export const StyledTitle = styled.p`
  flex: 1;

  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
  color: ${theme.colors.darkBlue};

  text-align: center;

  ${px(3)}
  ${py(2.5)}
`;

export const StyledClearAll = styled.p`
  color: ${theme.colors.aquaMarine};
  font-size: 16px;
  font-weight: 600;

  ${px(3)}
  ${py(2.5)}
`;

export const StyledBody = styled.div`
  flex: 1;
  overflow-y: scroll;
`;

export const StyledFooter = styled.div`
  ${px(3)}
  ${py(2.5)}
`;

export const StyledResultsButton = styled(StatefulButton).attrs({ buttonType: PRIMARY_BUTTON })`
  height: 56px;
`;
